'use client';

import { usePathname } from 'next/navigation';

import Breadcrumbs from '@/components/organisms/Breadcrumbs/Breadcrumbs';

/**
 * Renders the breadcrumb trail below the hero section of the page.
 *
 * This reflects the updated UX decision to show breadcrumbs under the hero
 * for pages that use the main layout with a hero section.
 */
export default function PageBreadcrumbs() {
  const pathname = usePathname();

  const shouldRenderBreadcrumbs = pathname && pathname !== '/';

  if (!shouldRenderBreadcrumbs) {
    return null;
  }

  return (
    <div className="border-surface-soft bg-surface-soft border-t px-4 py-4 sm:px-6 sm:py-6 lg:px-8 lg:py-5">
      <Breadcrumbs path={pathname} />
    </div>
  );
}
